/**
 * AI Chat Credits Admin API Service
 * Uses chat server base URL.
 */

function getChatBaseUrl() {
  const override = localStorage.getItem('chatBaseUrl');
  if (override) return override;
  const env = localStorage.getItem('env') === 'true';
  return env
    ? 'https://prod-chat-module-api.dugoutlive.com'
    : 'https://chat-module-api.dugoutlive.com';
}

function getAuthHeaders() {
  const token = sessionStorage.getItem('sessionToken');
  return token ? { Authorization: `Bearer ${token}`, auth: token } : {};
}

async function handleResponse(res) {
  if (!res.ok) {
    let msg = `Request failed: ${res.status}`;
    try { const b = await res.json(); msg = b.message || b.error || msg; } catch {}
    throw new Error(msg);
  }
  return res.json();
}

/** GET /admin/ai-chat/credits — list all users with credit balances (paginated) */
export async function listUserCredits(limit = 100, offset = 0) {
  const res = await fetch(
    `${getChatBaseUrl()}/admin/ai-chat/credits?limit=${limit}&offset=${offset}`,
    {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    }
  );
  return handleResponse(res);
}

/** GET /admin/ai-chat/credits/user/:userId — get a specific user's balance + stats */
export async function getUserCredits(userId) {
  const res = await fetch(
    `${getChatBaseUrl()}/admin/ai-chat/credits/user/${encodeURIComponent(userId)}`,
    {
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
    }
  );
  return handleResponse(res);
}

/** PUT /admin/ai-chat/credits/user/:userId — set absolute credit balance */
export async function setUserCredits(userId, credits) {
  const res = await fetch(
    `${getChatBaseUrl()}/admin/ai-chat/credits/user/${encodeURIComponent(userId)}`,
    {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify({ credits: Number(credits) }),
    }
  );
  return handleResponse(res);
}

/** POST /admin/ai-chat/credits/user/:userId/add — grant (increment) credits */
export async function addUserCredits(userId, amount) {
  const res = await fetch(
    `${getChatBaseUrl()}/admin/ai-chat/credits/user/${encodeURIComponent(userId)}/add`,
    {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', ...getAuthHeaders() },
      body: JSON.stringify({ amount: Number(amount) }),
    }
  );
  return handleResponse(res);
}
